import { ContractTemplateSummaryOutDTO } from "./contract-template-summary.out.dto";
import { Type } from "class-transformer";

export class ContractTemplatePaginatedOutDTO {
  @Type(() => ContractTemplateSummaryOutDTO)
  contractTemplates!: ContractTemplateSummaryOutDTO[];

  total!: number;
}
